module.exports = __webpack_public_path__ + "static/media/thetawhite.f2bea84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thetawhite.png
// module id = 454
// module chunks = 0